import { gql } from '@apollo/client';

// Either templateId OR params must be provided (not both)
export const PREVIEW_EXIT_STRATEGY = gql`
  query PreviewExitStrategy(
    $templateId: ID, 
    $params: ExitStrategyParamsInput, 
    $portfolioId: ID!, 
    $tokenId: ID!
  ) {
    previewExitStrategy(
      templateId: $templateId, 
      params: $params, 
      portfolioId: $portfolioId, 
      tokenId: $tokenId
    ) {
      levels {
        price
        amount
        percentage
        value
        roi
        belowCost
      }
      totalSellAmount
      totalProceeds
      costBasis
      estimatedPnL
      estimatedROI
      # Warning info for levels below cost basis
      levelsAtLoss
      amountAtLoss
      lossAmount
      averageCost
    }
  }
`;
